import {
    GoogleAnalyticsEventParameters,
    GoogleAnalyticsPrimitive,
    GoogleAnalyticsUserProperties
} from "./types";

const filterDefinedProperties = (
    properties: Record<string, GoogleAnalyticsPrimitive | undefined>
): Record<string, GoogleAnalyticsPrimitive> => {
    return Object.fromEntries(
        Object.entries(properties).filter(
            ([, value]) => value !== undefined && value !== null && value !== ""
        )
    ) as Record<string, GoogleAnalyticsPrimitive>;
};

export const getPageViewParameters = (
    pathname: string,
    search: string
): GoogleAnalyticsEventParameters =>
    filterDefinedProperties({
        page_path: `${pathname}${search}`,
        page_title: document.title,
        page_location: window.location.href,
        viewport_size: `${window.innerWidth}x${window.innerHeight}`
    });

export const trackGoogleAnalyticsEvent = (
    eventName: string,
    parameters: GoogleAnalyticsEventParameters = {}
) => {
    if (!window.gtag || !eventName) return;

    window.gtag("event", eventName, filterDefinedProperties(parameters));
};

export const setGoogleAnalyticsUserId = (
    measurementId: string,
    userId?: string
) => {
    if (!window.gtag) return;

    window.gtag("config", measurementId, {
        send_page_view: false,
        user_id: userId
    });
};

export const setGoogleAnalyticsUserProperties = (
    properties: GoogleAnalyticsUserProperties
) => {
    if (!window.gtag) return;

    const filteredProperties = filterDefinedProperties(properties);

    if (Object.keys(filteredProperties).length === 0) return;

    window.gtag("set", "user_properties", filteredProperties);
};

export const initializeGoogleAnalytics = (measurementId: string) => {
    if (window.gtag) return;

    const script = document.createElement("script");
    script.id = "google-analytics-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    const dataLayer = window.dataLayer || [];
    window.dataLayer = dataLayer;
    window.gtag = function () {
        // eslint-disable-next-line prefer-rest-params
        dataLayer.push(arguments);
    };

    window.gtag("js", new Date());
    window.gtag("config", measurementId, {
        send_page_view: false,
        allow_google_signals: true,
        allow_ad_personalization_signals: false
    });
};
